module.exports = __webpack_public_path__ + "static/media/homeBackground.1fe47f09.jpg";